import { makeQuery } from 'shared/utilities';
import { IEducationLinkModel } from 'shared/models';

type ResponseType = {
    items: IEducationLinkModel[];
};

export const educationLinksQuery = async function () {
    return await makeQuery<ResponseType>('/education-links');
}
